import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/LoginComponent';
import ServicePage from './components/ServiceComponent';
import AboutPage from './views/AboutPage';
import Activate from './views/Activate';
import Post from './components/PostComponent';
import PartnerComponent from './components/PartnerComponent/PartnerComponent';
import AddPartnerComponent from './components/AdminComponent/AddPartnerComponent';
import EditPartnerComponent from './components/AdminComponent/EditPartnerComponent';
import Layout from './components/LayoutComponent'
import DashboardCompoent from './components/AdminComponent/DashboardCompoent';

import CarMasterComponent from './components/AdminComponent/CarMasterComponent';


import BranchComponent from './components/PartnerComponent/BranchComponent';
import BranchTable from './views/PartnerView/BranchTable';
import BranchTableComponent from './components/PartnerComponent/BranchTableComponent';
import BranchTableAdminComponent from './components/AdminComponent/BranchTableComponent';
import NotFound from './views/NotFound';

import ServiceComponent from './components/PartnerComponent/ServiceComponent';
import NewServiceComponent from './components/PartnerComponent/NewServiceComponent';
import EditServiceComponent from './components/PartnerComponent/EditServiceComponent';
import BranchDetailsList from './views/PartnerView/BranchIdForm';
import BranchDetailsForm from './views/PartnerView/BranchIdForm';
import BranchEditForm from './views/PartnerView/BranchEditData';
import BranchIdComponent from './components/PartnerComponent/BranchIdComponent';
import BranchAdminView from './views/PartnerView/BranchAdminView';
import AdminBranchComponent from './components/AdminComponent/AdminBranchComponent';
import PartnerEmployeeAddComponent from './components/PartnerComponent/PartnerEmployeeAddComponent';
import PartnerPackageAddComponent from './components/PartnerComponent/PartnerPackageAddComponent';
import OrderComponent from './components/AdminComponent/OrderComponent';
import AdminOrderComponent from './components/AdminComponent/AdminOrderComponent';
import EmployeeComponent from './components/PartnerComponent/EmployeeComponent';
import EmployeeEditComponent from './components/PartnerComponent/EmployeeEditComponent';
import PartnerPackageListComponent from './components/PartnerComponent/PartnerPackageListComponent';
import CoupansOffersComponent from './components/PartnerComponent/CoupansOffersComponent';
import ViewsCoupansComponent from './components/PartnerComponent/ViewsCoupansComponent';
import CoupansEditComponent from './components/PartnerComponent/CoupansEditComponent';
import PartnerCoupanListComponent from './components/PartnerComponent/PartnerCoupanListComponent';
import CoupansEditData from './views/PartnerView/CoupansEditData';
import DisputeComponent from './components/AdminComponent/DisputeComponent';
import PartnerDashboardCompoent from './components/PartnerComponent/PartnerDashboardComponent';
import DashboardSelector from './DashboardSelector';
import ProductCategoryComponent from './components/AdminComponent/ProductCategoryComponent';
import ProductComponent from './components/PartnerComponent/ProductComponent';
import ProductListComponent from './components/PartnerComponent/ProductListComponent';
import EmailTestComponent from './components/AdminComponent/EmailTestComponent';
import ChecklistComponent from './components/AdminComponent/ChecklistComponent';
import DeleteAccountComponent from './components/DeleteAccountComponent';

const ProtectedRoute = ({ element }) => {
    const token = localStorage.getItem('token'); // Adjust based on your token storage

    return token ? element : <Navigate to="/login" replace />;
};
const AppRoutes = ({ showHeader }) => (

    <BrowserRouter>
        <Layout>
        <Routes>
         {/*Routes protected using token, new routes should be added in below format*/}
                <Route path="/about" element={<ProtectedRoute element={<AboutPage />} />} />
                <Route path="/service" element={<ProtectedRoute element={<ServicePage />} />} />
                <Route path="/carmaster" element={<ProtectedRoute element={<CarMasterComponent />} />} />
                <Route path="/partner" element={<ProtectedRoute element={<PartnerComponent />} />} />
                <Route path="/addpartner" element={<ProtectedRoute element={<AddPartnerComponent />} />} />
                <Route path="/editpartner" element={<ProtectedRoute element={<EditPartnerComponent />} />} />
                <Route path="/partnerservice" element={<ProtectedRoute element={<ServiceComponent />} />} />
                <Route path="/addservice" element={<ProtectedRoute element={<NewServiceComponent />} />} />
                <Route path="/post" element={<ProtectedRoute element={<Post />} />} />
                <Route path="/newbranch" element={<ProtectedRoute element={<BranchComponent />} />} />
                <Route path="/branch" element={<ProtectedRoute element={<BranchTableComponent />} />}/>
                <Route path="/allbranch" element={<ProtectedRoute element={<BranchTableAdminComponent />} />} />
                <Route path="/activate" element={<Activate />} />
                <Route path="/delete-account" element={<DeleteAccountComponent />} />
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/post3" element={<ProtectedRoute element={<Post />} />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/branchdetails" element={<ProtectedRoute element={<BranchComponent />} />} />
                <Route path="/editpartner/:id/:edit" element={<ProtectedRoute element={<EditPartnerComponent />} />} />
                <Route path="/editpartnerservice/:id/:edit" element={<ProtectedRoute element={<EditServiceComponent />} />} />
                <Route path="/edit-branch" element={<ProtectedRoute element={<BranchEditForm />} />} />
                <Route path="/edit-branch/:id/:edit" element={<ProtectedRoute element={<AdminBranchComponent/>} />} />
                <Route path="/dashboard" element={<ProtectedRoute element={<DashboardSelector />} />} />
                <Route path="/dashboard" element={<ProtectedRoute element={<DashboardSelector />} />} />
                {/* <Route path="/edit-branch" element={<ProtectedRoute element={<BranchIdComponent />} />} /> */}
                <Route path='/employeeadd' element={<ProtectedRoute element={<PartnerEmployeeAddComponent />} />} />
                <Route path="/allemployee" element={<ProtectedRoute element={<EmployeeComponent />} />} />
                <Route path="/editemployee/:id/:edit" element={<ProtectedRoute element={<EmployeeEditComponent/>} />} />
                <Route path='/packageadd' element={<ProtectedRoute element={<PartnerPackageAddComponent />} />} />
                <Route path='/orders' element={<ProtectedRoute element={<OrderComponent />} />} />
                <Route path="/vieworder/:id" element={<ProtectedRoute element={<AdminOrderComponent />} />} />
                <Route path="/viewpackage" element={<ProtectedRoute element={<PartnerPackageListComponent />} />} />
                <Route path="/viewpackage/:id/:edit" element={<ProtectedRoute element={<PartnerPackageListComponent />} />} />
                <Route path="/viewproduct/:id/:edit" element={<ProtectedRoute element={<ProductListComponent />} />} />
                <Route path="/productcategory" element={<ProtectedRoute element={<ProductCategoryComponent />} />} />
                <Route path="/addproduct" element={<ProtectedRoute element={<ProductComponent />} />} />
                <Route path="/coupans" element={<ProtectedRoute element={<CoupansOffersComponent/>}/>}/>
                <Route path="/viewcoupans"element={<ProtectedRoute element={<ViewsCoupansComponent/>}/>}/>
                <Route path='/Coupansedit/:id/:edit'element={<ProtectedRoute element={<CoupansEditComponent/>}/>}/>
                <Route path='/CoupanList' element={<ProtectedRoute element={<PartnerCoupanListComponent/>}/>}/>
                <Route path="/CoupansEditData/:id/:edit" element={<ProtectedRoute element={<CoupansEditData/>}/>}/>
                <Route path="/Dispute" element={<ProtectedRoute element={<DisputeComponent/>}/>}/>
                <Route path="/Products" element={<ProtectedRoute element={<ProductListComponent />} />} />
                <Route path="/testemail" element={<ProtectedRoute element={<EmailTestComponent />} />} />
                <Route path="/checklists" element={<ProtectedRoute element={<ChecklistComponent />} />} />
                </Routes>
        </Layout>
    </BrowserRouter>
);

export default AppRoutes;
